import React, { useEffect, useState } from "react";
import { Card, CardBody, CardHeader } from "../card/card";
import ConfirmationDlg from "../ConfirmationDlg";
import NormalSelect from "../form/HorizontalNormalSelect";
import { checklist as checklistAPI } from "../../api";
import { Form } from "react-bootstrap";
import Select, { StylesConfig } from "react-select";

const colourStyles = {
  control: (styles) => ({
    ...styles,
    backgroundColor: "transparent",
    zIndex: 99,
  }),
  input: (styles) => ({
    ...styles,
    color: "white",
  }),
  menu: (styles) => ({
    ...styles,
    color: "grey",
  }),
};

export const Task = ({
  showAddChecklist,
  onChange,
  value,
  title = "Task List",
}) => {
  const [tasks, setTasks] = useState(value);
  const [openChecklist, setOpenChecklist] = useState(false);
  const [openPreview, setOpenPreview] = useState(false);
  const [checklist, setChecklist] = useState([]);
  const [selectedChecklist, setSelectedChecklist] = useState([]);
  const addTask = () => {
    let copy = [...tasks];
    copy = [
      ...copy,
      {
        task_name: "",
        task_type: "Status",
        task_option: [""],
      },
    ];
    setTasks(copy);
  };

  const handleTaskChange = (e, index) => {
    let copy = [...tasks];
    copy[index].task_name = e.target.value;
    setTasks(copy);
  };

  const handleTaskTypeChange = (e, index) => {
    let copy = [...tasks];
    copy[index].task_type = e.target.value;
    setTasks(copy);
  };

  const deleteTask = (index) => {
    let copy = [...tasks];
    copy.splice(index, 1);
    setTasks(copy);
  };

  const handleOptionChange = (e, indexTask, indexOption) => {
    let copy = [...tasks];
    copy[indexTask].task_option[indexOption] = e.target.value;
    setTasks(copy);
  };
  const handleAddOption = (indexTask) => {
    let copy = [...tasks];
    copy[indexTask].task_option.push("");
    setTasks(copy);
  };

  const handleDeleteOption = (indexTask, indexOption) => {
    let copy = [...tasks];
    copy[indexTask].task_option.splice(indexOption, 1);
    setTasks(copy);
  };

  useEffect(() => {
    onChange(tasks);
  }, [tasks]);

  useEffect(() => {
    setTasks(value);
  }, [value]);

  const getChecklistTemplate = async () => {
    const result = await checklistAPI.list({ company: true });
    if (result.ok) {
      const body = await result.json();
      setChecklist(body.data);
    }
  };

  const handleApplyChecklist = () => {
    if (selectedChecklist.length > 0) {
      const c = checklist.filter((c) =>
        selectedChecklist.some((sl) => sl.value == c.id)
      );
      let newTasks = [...tasks];
      c.map((c) => {
        newTasks = [...newTasks, ...c.tasks];
      });
      setTasks(newTasks);
      setOpenChecklist(false);
      setSelectedChecklist([]);
    }
  };

  const selectChecklist = (value) => {
    setSelectedChecklist(value);
  };

  useEffect(() => {
    if (openChecklist) {
      getChecklistTemplate();
    }
  }, [openChecklist]);
  return (
    <Card>
      <CardHeader>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <div>{title}</div>
          <div>
            <button
              onClick={addTask}
              className="btn btn-sm btn-outline-theme"
              style={{ marginRight: "10px" }}
            >
              Add Task
            </button>

            {showAddChecklist && (
              <>
                <button
                  onClick={() => setOpenChecklist(true)}
                  className="btn btn-sm btn-outline-theme"
                  style={{ marginRight: "10px" }}
                >
                  Insert Checklist
                </button>
                <ConfirmationDlg
                  type="submit"
                  onClose={() => setOpenChecklist(false)}
                  title={"Select Checklist"}
                  open={openChecklist}
                  onSubmit={handleApplyChecklist}
                >
                  <div
                    className="mb-3 force-transparent"
                    style={{ zIndex: 9999999 }}
                  >
                    <label className="form-label">Checklist</label>
                    <Select
                      isMulti
                      closeMenuOnSelect={false}
                      styles={colourStyles}
                      options={checklist.map((i) => {
                        return {
                          value: i.id,
                          label: i.name + ` (${i.tasks.length})`,
                        };
                      })}
                      value={selectedChecklist}
                      onChange={(e) => {
                        selectChecklist(e);
                      }}
                    />
                  </div>
                </ConfirmationDlg>
              </>
            )}

            <button
              onClick={() => {
                setOpenPreview(true);
              }}
              className="btn btn-sm btn-outline-theme"
              style={{ marginRight: "10px" }}
            >
              Preview
            </button>
            <ConfirmationDlg
              btnSubmitText={"OK"}
              hideCancelBtn
              type="submit"
              onClose={() => setOpenPreview(false)}
              title={"Task Preview"}
              open={openPreview}
              onSubmit={() => setOpenPreview(false)}
            >
              <table
                style={{
                  width: "100%",
                  borderCollapse: "separate",
                  borderSpacing: ".5em 1em",
                }}
              >
                <thead>
                  <tr>
                    <th>No</th>
                    <th>Task</th>
                  </tr>
                </thead>
                <tbody>
                  {tasks.map((ts, indexTask) => (
                    <tr key={indexTask}>
                      <td style={{ verticalAlign: "top" }}>{indexTask + 1}</td>
                      <td style={{ verticalAlign: "top" }}>
                        {ts.task_type == "Status" && (
                          <NormalSelect
                            name={"task_option_selected"}
                            label={ts.task_name}
                            list={[
                              "Open",
                              "In Progress",
                              "Hold",
                              "Complete",
                            ].map((v) => ({
                              name: v,
                              value: v,
                            }))}
                          />
                        )}
                        {ts.task_type == "Text Field" && (
                          <>
                            {ts.task_name}
                            <input
                              name={"task_option_selected"}
                              className="form-control mt-2"
                              type="text"
                            />
                          </>
                        )}
                        {ts.task_type == "Multiple Choice" && (
                          <NormalSelect
                            name={"task_option_selected"}
                            label={ts.task_name}
                            list={ts.task_option.map((v) => ({
                              name: v,
                              value: v,
                            }))}
                          />
                        )}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </ConfirmationDlg>
          </div>
        </div>
      </CardHeader>
      <CardBody>
        {tasks.length > 0 ? (
          <table
            style={{
              width: "100%",
              borderCollapse: "separate",
              borderSpacing: ".5em 1em",
            }}
          >
            <thead>
              <tr>
                <th>No</th>
                <th>Task</th>
                <th>Task Type</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {tasks.map((ts, indexTask) => (
                <tr key={indexTask}>
                  <td style={{ verticalAlign: "top" }}>{indexTask + 1}</td>
                  <td style={{ verticalAlign: "top" }}>
                    <input
                      className="form-control"
                      type="text"
                      onChange={(e) => handleTaskChange(e, indexTask)}
                      value={ts.task_name}
                    />

                    {ts.task_type == "Multiple Choice" && (
                      <div>
                        {ts.task_option.map((option, indexOption) => (
                          <div
                            key={indexOption}
                            style={{ display: "flex", paddingTop: 10 }}
                          >
                            <div style={{ marginRight: 5, width: "100%" }}>
                              <input
                                className="form-control"
                                value={option}
                                onChange={(e) =>
                                  handleOptionChange(e, indexTask, indexOption)
                                }
                              ></input>
                            </div>

                            <button
                              disabled={ts.task_option.length == 1}
                              className="btn btn-outline-danger"
                              onClick={() => {
                                handleDeleteOption(indexTask, indexOption);
                              }}
                            >
                              x
                            </button>
                          </div>
                        ))}

                        <div className="d-flex justify-content-center align-items-center m-2">
                          <button
                            onClick={() => {
                              handleAddOption(indexTask);
                            }}
                            className="btn btn-outline-success btn-sm"
                          >
                            add more option +{" "}
                          </button>
                        </div>
                      </div>
                    )}
                  </td>
                  <td style={{ verticalAlign: "top" }}>
                    <select
                      value={ts.task_type}
                      onChange={(e) => handleTaskTypeChange(e, indexTask)}
                      className="form-control"
                    >
                      <option value="Status">Status</option>
                      <option value="Text Field">Text Field</option>
                      <option value="Multiple Choice">Multiple Choice</option>
                    </select>
                  </td>
                  <td style={{ verticalAlign: "top" }}>
                    <div
                      className="btn btn-sm btn-outline-danger"
                      onClick={() => {
                        deleteTask(indexTask);
                      }}
                    >
                      Delete
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        ) : (
          <div className="text-center text-muted py-4">
            <i className="fa fa-list fa-3x mb-3"></i>
            <p>No tasks yet. Click "Add Task" to start.</p>
          </div>
        )}
      </CardBody>
    </Card>
  );
};
